import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'spw-loading',
  styleUrl: 'spw-loading.scss',
  shadow: true,
})
export class SpwLoading {
  /** Permet de spécifier un texte de chargement */
  @Prop() text?: string = 'Chargement...';

  render() {
    return (
      <Host>
        <div class="spw-loading">
          <div class="spw-loading__spinner"></div>
          <p class="spw-loading__text">{this.text}</p>
        </div>
      </Host>
    );
  }
}
